import classNames from "classnames";
import React from "react";
import { useDispatch } from "react-redux";
import { farmLpt, rewards, rewardsList } from "../placeholder";
import { confirmWallet } from "../redux/actions/modal";
import ATitle from "../components/ATitle";
import List from "../modals/parts/List";
import Wrapper from "../components/Wrapper";
import useDropdown from "../components/hooks/useDropdown";
import { useState, useEffect, useContext } from "react";
import { Web3Context } from "../contexts/Web3Context";
import { getProof, verify } from "../utils/merkleTree";
import {
  getTokens,
  getTokensFromMultiple,
  spentERC20,
} from "../apis/distribution";
import { getDistributionContract } from "../apis/blockchain";
import axios from "axios";
import Search from "../components/Search";
import Hint from "../components/Hint/Hint";

const Item = ({ id, currencies, apr, rewardsCycle, earned, style = {} }) => {
  const [ref, styles, open, setOpen] = useDropdown({ speed: 100 });
  const dispatch = useDispatch();
  const Swal = require("sweetalert2");
  const web3Context = useContext(Web3Context);
  const [userRewardsArray, setUserRewardsArray] = useState([]);

  const onClaim = async () => {
    if (userRewardsArray.length === 0) {
      return;
    } else if (userRewardsArray.length === 1) {
      await getTokens(
        await getDistributionContract(web3Context.web3.web3Provider),
        userRewardsArray[0].id,
        userRewardsArray[0].proof,
        web3Context.currentAccountAddress,
        userRewardsArray[0].amounts[0][0]
      );
    } else if (userRewardsArray.length > 1) {
      await getTokensFromMultiple(
        await getDistributionContract(web3Context.web3.web3Provider),
        userRewardsArray.map((reward) => reward.id),
        userRewardsArray.map((reward) => reward.proof),
        web3Context.currentAccountAddress,
        userRewardsArray.map((reward) => reward.amounts[0][0])
      );
    }
    Swal.fire({
      text: "Successfully claimed tokens",
      icon: "success",
      confirmButtonText: "Ok",
    });
    try {
      await axios.post(
        `https://us-central1-asko-borrower-rewards.cloudfunctions.net/setUserClaimed`,
        {
          airdropIds: userRewardsArray.map((each) => each.parentId),
          address: web3Context.currentAccountAddress,
        }
      );
    } catch (e) {
      console.log(e);
    }
  };

  const getDistribution = async (rewardsArray, userAddress) => {
    let id,
      participants,
      addressToLeaf,
      valified,
      hasSpent,
      parentId,
      proof,
      validAirdrop,
      amounts;
    for (let i = 0; i < rewardsArray.length; i++) {
      parentId = rewardsArray[i].id;
      ({ id, participants, addressToLeaf } = rewardsArray[i].data);
      valified = verify(participants, addressToLeaf[userAddress]);
      if (!valified) {
        continue;
      }
      try {
        const distributionContract = await getDistributionContract(
          web3Context.web3.web3Provider
        );
        hasSpent = await spentERC20(distributionContract, id, userAddress);
      } catch (error) {
        continue;
      }
      if (hasSpent) {
        continue;
      }
      proof = getProof(participants, addressToLeaf[userAddress]);
      validAirdrop = {
        parentId,
        id,
        proof,
        amounts: addressToLeaf[userAddress]
          .split(",")
          .map((amounts) => amounts.split(" ").splice(1)),
      };
      setUserRewardsArray((prevState) => [...prevState, validAirdrop]);
    }
  };

  useEffect(async () => {
    if (web3Context.currentAccountAddress) {
      try {
        await axios
          .get(
            `https://us-central1-asko-borrower-rewards.cloudfunctions.net/getUserRewards?address=${web3Context.currentAccountAddress}`
          )
          .then(async (res) => {
            await getDistribution(res.data, web3Context.currentAccountAddress);
          });
      } catch (e) {
        console.log(e);
      }
    }
  }, [web3Context.currentAccountAddress]);

  return (
    <div
      className={classNames("farm-item", { opened: open })}
      style={style}
      key={id}
    >
      <div className="farm-item__rate">
        <div className="farm-item__rate-wrapper">
          <span>C1</span>
        </div>
      </div>
      <div className="farm-item__content">
        <div className="farm-item__information" onClick={() => setOpen(!open)}>
          <div className="reward-item__col">
            <span className="reward-item__col-value">
              <img
                src={currencies.icon}
                alt="icon"
                className="farm-item__col-icon"
              />
              <div className="reward-item__col-name">{currencies.name}</div>
            </span>
          </div>
          <div className="reward-item__col reward-item__col_apr">
            <span className="reward-item__col-value">
              <div className="reward-item__col-name">
                Borrower APR: <span>{apr}%</span>
              </div>
            </span>
          </div>
          <div className="reward-item__col">
            <button className="farm-item__btn-dropdown">
              <img
                src="/assets/images/page-icons/arrow-dropdown.svg"
                alt="arrow"
              />
            </button>
          </div>
        </div>
        <div ref={ref} style={styles} className="farm-item__dropdown">
          <div className="rewards-window">
            <List className="rewards-list">
              <List.Item title="Category" value={rewards.category} />
              <List.Item title="rASKO Rewards APR" value={rewards.apr} />
              <List.Item
                title="Current rASKO token price:"
                value={rewards.price}
              />
              <List.Item
                title="Total rASKO rewards to Claim:"
                value={rewards.claim}
              />
            </List>

            <List className="rewards-list rewards-list__mt">
              <List.Item
                title="Total rewards earned this period:"
                value={rewards.period}
              />
              <List.Item title="Borrower's effective APR" value={rewards.APR} />
            </List>

            <button
              className="rewards__button button-b"
              onClick={onClaim}
              disabled={userRewardsArray.length === 0}
            >
              Claim
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function () {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  return (
    <div className="rewards">
      <header className="farm__header">
        <ATitle className="farm__title" text="Borrower’s Rewards" />
        <Search
          className="farm__search"
          placeholder="Search"
          name="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </header>
      <div className="farm-list">
        <div className="farm-list__wrapper">
          <Wrapper
            className="farm-list__items custom-scrollbar"
            marginTop={20}
            showItems={5}
          >
            {rewardsList.map((item) => (
              <Item {...item} key={item.id} />
            ))}
          </Wrapper>
        </div>
      </div>
    </div>
  );
}
